import * as React from 'react';

interface TableIconProperties {
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

const TableIcon = ({ color = '#000', ...props }: TableIconProperties): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" width="1em" height="1em" {...props}>
    <path
      style={{
        fill: 'none',
        stroke: color,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5px',
      }}
      d="M8.25 3h15M8.25 12h15M8.25 21h15M.8 18.36a1.5 1.5 0 1 1 1.45 1.89 1.5 1.5 0 1 1-1.45 1.9M.75 11.25a1.5 1.5 0 0 1 1.5-1.5h0a1.5 1.5 0 0 1 1.5 1.5h0a2.16 2.16 0 0 1-.47 1.34L.75 14.25h3M.75.75h.75a.76.76 0 0 1 .75.75v5.25M.75 6.75h3"
      transform="scale(5.83333)"
    />
  </svg>
);

export default TableIcon;
